export const ENGLISH_TRANSLATIONS = {
    text: {
        adult: 'дорослий (en)',
        school: 'учнівський (en)',
        student: 'студентський (en)',
        pensionary: 'пенсійний (en)',
        preferential: 'пільговий (en)',
    }
}
